<h2 nz-typography translate>messages.title</h2>
<app-alert></app-alert>
<nz-card class="light">
  <div class="app-new-message">
    <div class="app-new-message__recipient-data">
      <span translate>messages.newMessageThread.title</span>
      <span translate>messages.newMessageThread.to</span>
      <span [params]="{ bankName }" translate>messages.customerService</span>
    </div>
    <div class="app-new-message__form">
      <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="startMessageThread()">
        <nz-form-item>
          <nz-form-label translate>messages.newMessageThread.subject</nz-form-label>
          <nz-form-control>
            <input type="text" nz-input nzSize="large" [maxlength]="messageSubjectLength" formControlName="subject" data-cy="messages-new-subject-input" />
          </nz-form-control>
        </nz-form-item>

        <app-send-message [form]="form" [rowHeight]="10"></app-send-message>
        <div class="app-new-message__form-footer">
          <div class="attachment-container">
            <app-file-upload (uploading)="fileUploading($event)" (changed)="fileListUpdated($event)"></app-file-upload>
          </div>
          <div class="app-new-message__form-footer__buttons">
            <button type="submit" nz-button nzType="primary" [disabled]="!form.valid || uploading" data-cy="messages-new-send-button" translate>
              messages.newMessageThread.send
            </button>
            <button type="button" nz-button nzType="link" (click)="cancel()" translate>messages.newMessageThread.cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</nz-card>
